import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticatedHttpService } from './authenticatedhttp.service';

import { MCHAvailableProductLine } from '../model/mchavailableproductline';

import { ServiceUtilities } from './service-utilities';
import { ApplicationStateService } from './application-state.service';
import { UserFavoritesService } from './user-favorites.service';
import { LoadingSpinnerService } from "./loading-spinner.service";

import * as _ from 'lodash';

@Injectable()
export class MCHAvailableProductLineService {
    private baseUrl;
    private _mchavailableproductlineCache: MCHAvailableProductLine[];

    constructor(
        private _http: AuthenticatedHttpService
    ) {
        this.baseUrl = _http.getBaseURLFromCookie();
    }

    getMCHAvailableProductLines(refresh = false): Observable<MCHAvailableProductLine[]> {
        if (this._mchavailableproductlineCache && !refresh) {
            return Observable.of(this._mchavailableproductlineCache)
                .map(facs => {
                    this._mchavailableproductlineCache = _.cloneDeep(this._mchavailableproductlineCache);
                    return this._mchavailableproductlineCache;
                });
        } else {
            return this._http.get(`${this.baseUrl}/api/mchavailableproductlines`)
                .map(x => {
                    return x.json();
                })
                .catch(this._http.handleError);

        }
    }

    saveAvailableProductLines(recordsToSave: MCHAvailableProductLine[]): Observable<MCHAvailableProductLine[]> {
        if (recordsToSave !== undefined && recordsToSave !== null) {

        }
        return this._http.put(`${this.baseUrl}/api/mchavailableproductlines`, JSON.stringify(recordsToSave))
            .map(x => {
                return x.json();
            })
            .catch(this._http.handleError);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/mchavailableproductline.service.ts